import React, { useEffect } from "react";
import { Grid, Box } from "@material-ui/core";
import StepperSubHeader from "../../../../components/Header/StepperSubHeader.component";
import { useSidebarContext } from "../../../../context/sidebar/sidebar.provider";
import Loader from "../../../../components/LoaderSplash/Loader.component";
import {
  ENDORSEMENTS_STEPS,
  useEndorsementsDataContext,
} from "../../../../context/endorsements/endorsements.provider";

const InitFlow = () => {
  const { loading, step, goBack, cleanEndorsementBody } =
    useEndorsementsDataContext();
  const { setStepperTitle, setStep } = useSidebarContext();

  useEffect(() => {
    setStepperTitle(ENDORSEMENTS_STEPS[step].title);
    setStep(step);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  return (
    <>
      <Box display={loading ? "block" : "none"}>
        <Loader action={"Cargando información"}></Loader>
      </Box>
      <StepperSubHeader
        goBack={goBack}
        step={step}
        closeAction={cleanEndorsementBody}
        totalSteps={ENDORSEMENTS_STEPS.length}
      ></StepperSubHeader>
      <Grid container justify={"center"} style={{ height: "calc(100% - 4px)" }}>
        <Grid item xs={11} md={9} lg={8} xl={7}>
          <Grid container style={{ height: "100%", marginBottom: "25px" }}>
            <Grid item xs={12}>
              {ENDORSEMENTS_STEPS[step].content}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default InitFlow;
